import api from "../api/api";

export const trackVisit = async () => {
  try {
    let visitorToken = localStorage.getItem("visitor_token");

    if (!visitorToken) {
      visitorToken =
        crypto.randomUUID?.() ||
        Math.random().toString(36).substring(2) + Date.now();

      localStorage.setItem("visitor_token", visitorToken);
    }

    await api.post("/visit", {
      visitor_token: visitorToken,
    });
  } catch (err) {
    console.error("Visit tracking failed", err);
  }
};